import { faCloudArrowUp } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { styled } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { StyledMUIButton } from 'src/components/Button';

type SaveButtonProps = Readonly<{
  uploadFiles: () => void;
  disabled?: boolean;
}>;

export function FileDetailsSaveButton({ uploadFiles, disabled }: SaveButtonProps) {
  const { t } = useTranslation('uploads');
  return (
    <StyledMUIButton onClick={uploadFiles} disabled={disabled} data-testid="upload-files-button">
      <UploadIcon icon={faCloudArrowUp} />
      {t('uploadFiles')}
    </StyledMUIButton>
  );
}

const UploadIcon = styled(FontAwesomeIcon)`
  margin-right: 0.5rem;
`;
